import { render, staticRenderFns } from "./new-kanban-viewer.vue?vue&type=template&id=0aeab6ec&scoped=true&"
import script from "./new-kanban-viewer.vue?vue&type=script&lang=ts&"
export * from "./new-kanban-viewer.vue?vue&type=script&lang=ts&"
import style0 from "./new-kanban-viewer.vue?vue&type=style&index=0&id=0aeab6ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aeab6ec",
  null
  
)

export default component.exports